import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Aktuelles from './pages/Aktuelles';
import Leistungen from './pages/Leistungen';
import Blog from './pages/Blog';
import Datenschutz from './pages/Datenschutz';
import Impressum from './pages/Impressum';
import ÜberUns from './pages/ÜberUns';
import Kontakt from './pages/Kontakt';
import HomePage from './components/HomePage';
import Footer from './components/Footer';


function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage/>} />
        <Route path="aktuelles" element={<Aktuelles/>} />
        <Route path="leistungen" element={<Leistungen/>} />
        <Route path="blog" element={<Blog/>} />
        <Route path="datenschutz" element={<Datenschutz/>} />
        <Route path="impressum" element={<Impressum/>} />
        <Route path="überUns" element={<ÜberUns/>} />
        <Route path="kontakt" element={<Kontakt/>} />
        <Route path="footer" element={<Footer/>} />
      </Routes>
    </BrowserRouter>
  );
}; 

export default App;
